import { useQuery } from "react-query";
import AxiosT from "../setup/setup-axios";

async function fetchGetConfig() {
  const res = await AxiosT.get("/get-config");
  return res.data;
}

export function useGetConfig() {
  return useQuery("getConfig", fetchGetConfig);
}
